import Layout from "../layout/layout";
import { useAuth } from "../context/authContext";
import { useState } from "react";

const Profile = () => {
    const {
        name,
        userId,
        prefix,
        accountId,
        email,
        mobile,
    } = useAuth();
    const isTopUp = localStorage.getItem("isTopUp");
    const inActive = localStorage.getItem("inActive");

    const [message, setMessage] = useState("");

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);

            setMessage("Copied");
            setTimeout(() => {
                setMessage("");
            }, 3000);
        } catch (e) {

        }
    }

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8 m-auto">
                                <div className="card card-profile-01">
                                    <div className="card-header mb-3" style={{ background: "#914648" }}>
                                        <h5 className="text-center"> Profile </h5>
                                    </div>
                                    <div className="p-3 rounded shadow-sm">
                                        <div className="nav-profile p-3 text-center">
                                            <img alt="avatar" className="img-fluid b-r-10" src="siteadmin/images/woman.png" />
                                            <div className="mt-3">
                                                <span className="cus-prefix-text" style={{ color: "black" }}>{'('} {prefix + userId} {')'}</span>
                                                <span className={
                                                    'f-s-13 ' + (
                                                        inActive != 'true' && isTopUp === 'true'
                                                            ? 'text-success'
                                                            : 'text-danger'
                                                    )
                                                }>
                                                    {
                                                        isTopUp === 'true'
                                                            ? inActive == 'true'
                                                                ? ' InActive'
                                                                : ' Active'
                                                            : ' DeActive'
                                                    }
                                                </span>
                                                <p>{name}</p>
                                                <div className="mt-2">
                                                    <i className="fa fa-envelope mx-2"></i>
                                                    <span className="ml-2">{email}</span>
                                                </div>

                                                <div className="mt-1">
                                                    <i className="fa fa-phone mx-2"></i>
                                                    <span className="ml-2">{mobile}</span>
                                                </div>
                                                <div className="col-md-10 m-auto mt-2 text-light">
                                                    <div className="input-txt-display cursorPointer" onClick={() => handleCopy(accountId)}>
                                                        <span className="ellipsis-left">
                                                            {accountId}
                                                        </span>
                                                        &nbsp;
                                                        <i className="fa fa-copy mt-1"></i>
                                                    </div>
                                                </div>
                                                <div className="text-right text-success">
                                                    {message && <span>{message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default Profile;